import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMessageCircle, FiMapPin } = FiIcons;

const Footer = () => {
  const phoneNumber = "251-522-9131";
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12 border-t-4 border-red-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-white">
              <span className="text-red-600">cash</span>x24.com
            </h3>
            <p className="text-gray-400 mb-6">
              I help homeowners sell their properties quickly and without the stress of traditional listings. Fair offers, fast closings, and personal service every step of the way.
            </p>
            <div className="space-y-3">
              <a 
                href={`tel:${phoneNumber}`} 
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors"
              >
                <div className="bg-red-600 p-2 rounded-full">
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-white" />
                </div>
                <span>{phoneNumber}</span>
              </a>
              <a 
                href={`sms:${phoneNumber}`} 
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors"
              >
                <div className="bg-gray-700 p-2 rounded-full">
                  <SafeIcon icon={FiMessageCircle} className="w-5 h-5 text-white" />
                </div>
                <span>Text Tyler Directly</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 border-b border-gray-800 pb-2">Why Sell to Tyler</h4>
            <ul className="space-y-2 text-gray-400">
              <li>• Direct Cash Purchase</li>
              <li>• Close in as little as 7 days</li>
              <li>• No Repairs or Cleaning Needed</li>
              <li>• Tyler Pays All Closing Costs</li>
              <li>• Zero Commissions or Fees</li>
              <li>• Professional & Honest Service</li>
            </ul>
          </div>

          {/* Areas Served */}
          <div>
            <h4 className="text-lg font-semibold mb-4 border-b border-gray-800 pb-2">Areas I Buy In</h4>
            <div className="flex items-start space-x-3 text-gray-400">
              <SafeIcon icon={FiMapPin} className="w-5 h-5 text-red-600 mt-1" />
              <ul className="space-y-2">
                <li>Mobile, AL & Baldwin County</li>
                <li>Pensacola, FL & Gulf Breeze</li>
                <li>Daphne, Fairhope & Spanish Fort</li>
                <li>Gulf Shores & Orange Beach</li>
                <li>All surrounding Gulf Coast areas</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            © {currentYear} cashx24.com. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2 max-w-2xl mx-auto">
            Disclaimer: Tyler is a private real estate investor. We buy houses in any condition. Information provided is for general purposes and does not constitute legal or financial advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;